<template>
  <section class="text-center">
    <p>Etes-vous sûr de vouloir supprimer ce classement ?</p>
<div class="">
  <button @click="onSubmit" class="ml-3 btn btn-outline-success">OUI</button>
    </div>
  </section>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
name: "Delete",
  props: {
    classement: {
      type: Object
    }
  },
  data(){
    return{}
  },
components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosDeleteData',
    ]),
    onSubmit() {
      this.axiosDeleteData({
        table: 'classements',
        table_id: this.classement.classement_id,
      })
          .then(() => {
            location.reload(false)
          })
          .catch(() => {
          })
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/classements/components/Delete.vue